'use client'

import { BugsnagErrorBoundary } from '../bugsnag.client'

export default function BugsnagBoundary({ children }: { children: React.ReactNode }) {
  return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
}
